/*
 * @Author: Teemo Ding
 * @Date: 2022-03-16 10:03:00
 * @LastEditTime: 2022-03-22 13:37:43
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/OrderCancelModal/index.tsx
 */
import React, { Fragment } from 'react';
import { Form } from 'antd';
import { ModalFooter, Input, Checkbox, Label } from 'src/components/Antd';

import css from './css.module.less';

const OrderCancelModal = ({ onModalCancel, cancelOrder, disabledRestock }) => {
  const [form] = Form.useForm();
  const onFinish = (values) => {
    cancelOrder(values);
  };
  return (
    <Fragment>
      <Form
        name='orderCancelModal'
        onFinish={onFinish}
        form={form}
        className={css.modalContain}>
        <p>
          This action will cancel the order and cannot be reverted. Are you sure
          to cancel order?
        </p>

        <Form.Item
          name='remark'
          labelCol={{ span: 24 }}
          label={
            <Label
              title='Cancelation Reason (Optional)'
              nameKey='remark'
              textLength={100}
            />
          }>
          <Input size='large' maxLength='100' />
        </Form.Item>
        <Form.Item
          noStyle
          name='restock'
          initialValue={true}
          valuePropName='checked'>
          <Checkbox disabled={disabledRestock}>
            Restock remaining items after order cancelled
          </Checkbox>
        </Form.Item>
      </Form>
      <ModalFooter
        onOk={() => form.submit()}
        okText='Cancel Order'
        cancelText='Keep Order'
        danger
        onCancel={onModalCancel}
      />
    </Fragment>
  );
};

export default OrderCancelModal;
